import * as React from 'react'

import InstructorCard from '@/components/cards/instructor-card'
import CorporateCustomer from '@/components/sections/corporate-customer'
import FaqQuestionAnswerSection from '@/components/sections/faq-question-answer-section'
import FeedbackSection from '@/components/sections/feedback-section'
import LecturersSectionV2 from '@/components/sections/lecturers-section-v2'
import MoneyBackGuarantee from '@/components/sections/money-back-guarantee'
import ProjectSection from '@/components/sections/project-section'
import SectionHeroV3 from '@/components/sections/v3/section-hero-v3'
import FeaturePoweredSection from '@/components/sections/v4/feature-powered-section'
import FeatureSection from '@/components/sections/v4/feature-section'
import StatsSection from '@/components/sections/v4/stats-section'

interface LandingInstructor {
  id: number
  username: string
  position: string
  description: string
  avatar: string
  transform: string
  linkedin: string
  course: string
  module: string
  status?: string
}

interface FsdsLandingPageProps {
  lang: string
  isCourseEnrolled: boolean
  instructorsList: LandingInstructor[]
}

export default function FsdsLandingPage({ lang, isCourseEnrolled, instructorsList }: FsdsLandingPageProps) {
  const activeInstructors = instructorsList.filter(instructor => instructor?.status === 'active')
  const primaryInstructor = instructorsList[0]

  return (
    <>
      <SectionHeroV3 isCourseEnrolled={isCourseEnrolled} className={lang === 'en' ? 'mb-24' : ''} />
      <StatsSection className="sm:mb-0" />
      <CorporateCustomer className="py-20" />
      {lang === 'en' && <MoneyBackGuarantee isCourseEnrolled={isCourseEnrolled} />}
      <ProjectSection className="" />
      {lang === 'vi' && (
        <>
          <FeatureSection />
          <FeaturePoweredSection />
        </>
      )}
      <LecturersSectionV2 className="mb-24">
        <div className="mt-8 grid grid-cols-1 gap-4 sm:gap-6 md:mt-16 md:grid-cols-2 md:gap-8 lg:grid-cols-3 xl:gap-10">
          {lang === 'en' ? (
            primaryInstructor ? (
              <div key={primaryInstructor.id} className="flex justify-center lg:col-start-2">
                <InstructorCard {...primaryInstructor} />
              </div>
            ) : null
          ) : (
            activeInstructors.map((instructor, index) => (
              <div
                key={instructor.id}
                className={`flex justify-center ${
                  activeInstructors.length === 1 ||
                  (activeInstructors.length % 3 === 1 && index === activeInstructors.length - 1)
                    ? 'lg:col-start-2'
                    : ''
                }`}
              >
                <InstructorCard {...instructor} course={instructor.module} />
              </div>
            ))
          )}
        </div>
      </LecturersSectionV2>
      <FeedbackSection />
      <FaqQuestionAnswerSection />
    </>
  )
}
